import type { IconPrefix } from '@fortawesome/fontawesome-svg-core';

/**
 * Default Font Awesome prefix for `FaIcon`. Each app sets `prefix` from its theme
 * config (`fontAwesomePrefix`) when it registers that config.
 */
export const faIconConfig: { prefix: IconPrefix } = { prefix: 'fal' };
